<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zD9aAy/images/9781250130426.jpg?1712291643405" alt="This image is the cover for the book Best of Adam Sharp"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Best of Adam Sharp
      </h1>
      <p class="bookDescription body article font2">
        <p><b>From  the bestselling author of <i>The Rosie Project</i> comes a romantic novel about true love, second chances, and decades of great music.</b><br/><br/>Two decades ago, Adam Sharp’s piano playing led him into a passionate relationship with Angelina Brown, an intelligent and strong-willed actress. They had a chance at something more—but Adam didn’t take it.<br/><br/>Now, on the cusp of turning fifty, Adam likes his life. He’s happy with his partner Claire, he excels in music trivia at quiz night at the local pub, he looks after his mother, and he does the occasional consulting job in IT. But he can never quite shake off his nostalgia for what might have been. And then, out of nowhere, from the other side of the world, Angelina gets in touch. What does she want? Does Adam dare to live dangerously?<br/><br/>Set to the soundtrack of our lives, <i>The Best of Adam Sharp</i> by Graeme Simsion follows along with emotion and humor as one man looks back on his past and decides if having a second chance is worth the risk. <br/>One of <i>Glamour Magazine</i>'s “Most Anticipated Books of 2017”•"20 Must-Read Books for Spring 2017" from Redbook<br/><br/>Praise for <i>The Best of Adam Sharp</i>:<br/><br/>"This dazzling story about a former pianist who has a second chance in   midlife with his former actress flame will do some major heart-warming this Spring — and readers will never foresee the incredible ending."   —POPSUGAR <br/>"It's a fun sweet ride." —<i>The Washington Post<br/></i><br/>"Readers are already clamoring." —<i>Library Journal </i><br/><br/>“An extraordinary literary treat that reminds readers the best things in life have nothing to do with plans.” —<i>Redbook</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Graeme Simsion
      </h2>
      
      <p class="authorDescription body article">GRAEME SIMSION is a former IT consultant and the author of two nonfiction books on database design who decided, at the age of fifty, to turn his hand to fiction. His first novel, <I>The Rosie Project</I>, was published in 2013 and translation rights have been sold in over thirty-five languages. Graeme lives in Australia with his wife, Anne, and their two children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?14f852d6